module.exports = __webpack_public_path__ + "img/A3M11.2c5f4043.jpg";